import { combineReducers } from 'redux';

import authentication, { AuthReducer } from './authentication';
import userGroups, { UserGroupsReducer } from './userGroups';
import users, { UsersReducer } from './users';
import notifications, { NotificationReducer } from './notifications';
import shop, { ShopReducer } from './shop';
import featureFlags, { FeatureFlagsReducer } from './featureFlags';

export default combineReducers({
  authentication,
  userGroups,
  users,
  notifications,
  shop,
  featureFlags,
});

export interface RootState {
  authentication: AuthReducer;
  userGroups: UserGroupsReducer;
  users: UsersReducer;
  notifications: NotificationReducer;
  shop: ShopReducer;
  featureFlags: FeatureFlagsReducer;
}
